import './index.css'

import React, { Component } from 'react'

import TextInput from '../../../components/text-input'

class NameLangComponent extends Component {
  constructor(props) {
    super(props)

    this.state = { name: props.name, lang: props.lang }
  }

  update = (field, value) => {
    let model = this.state
    model[field] = value
    this.setState({ ...model })

    this.props.update(field, value)
  }

  render() {
    return (
      <React.Fragment>
        <div className="section-basics-line name-lang">
          <TextInput
            field="name"
            value={this.state.name}
            update={this.update}
            placeholder="Resume Name"
            onFocus={true}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default NameLangComponent
